import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { protectedResources } from '../Config/authConfig'

/**
 * Makes an authenticated POST request to the backend API
 */
const callApiWithToken = async (endpoint: string, data: any, accessToken: string): Promise<Response> => {
  return await fetch(protectedResources.backendApi.endpoint + endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
  });
};

const useAuthenticatedFetch = () => {
  const { instance, accounts } = useMsal();

  const fetchWithAuth = async (endpoint: string, data: any) => {
    // Define your token request including the required scopes.
    const tokenRequest = {
      scopes: protectedResources.backendApi.scopes,
      account: accounts[0],
    };

    try {
      // Acquire the token silently.
      const tokenResponse = await instance.acquireTokenSilent(tokenRequest);
      return await callApiWithToken(endpoint, data, tokenResponse.accessToken);
    } catch (error) {
      // Check if the error requires user interaction
      if (error instanceof InteractionRequiredAuthError) {
        // Fallback to interactive method when silent call fails
        try {
          const tokenResponse = await instance.acquireTokenPopup(tokenRequest);
          return await callApiWithToken(endpoint, data, tokenResponse.accessToken);
        } catch (popupError) {
          console.error('Interactive token acquisition failed:', popupError);
          throw new Error('Authentication failed. Please try logging in again.');
        }
      } else {
        console.error('Token acquisition failed:', error);
        throw new Error('Failed to authenticate request. Please try again.');
      }
    }
  };

  return { fetchWithAuth };
};

export default useAuthenticatedFetch;